<script setup>
import ACSA from './ACSA.vue';
import BaseAC1Aboard from './BaseAC1Aboard.vue';
import BaseAC1BMS from './BaseAC1BMS.vue';
import InREC from './InREC.vue';
import InRECCluster from './InRECCluster.vue';

import HostDevices from './HostDevices.vue';

import ModalConfig from './ModalConfig.vue';
import ModalControl from './ModalControl.vue';

import { shared } from './shared.js'

import packageInfo from "../../package.json"
const app_version = packageInfo.version
const current_year = (new Date()).getFullYear()
</script>

<template>
    <div class="container-fluid">
        <div class="row flex-nowrap">
            <main class="col ps-md-2 pt-2">
                <div class="container" style="max-width: 1800px;padding:10px">
                    <h4 class="float-end" style="margin-right: 20px;"><i class="bi"
                            :class="(connected ? 'bi-wifi text-success' : 'bi-wifi-off text-danger')"></i></h4>
                    <button class="btn btn-sm btn-primary float-end" 
                    style="margin-right: 20px;" data-bs-toggle="modal"
                        data-bs-target="#hostsModal" v-if="connected">Hosts</button>
                    <h1>RCV explorer</h1>
                    <hr>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" value="rcv-cloud" v-model="mqttBrokerSelector"
                                :disabled="connected">
                            <label class="form-check-label">rcv-cloud.nl</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" value="rcv-cloud-baseac1" v-model="mqttBrokerSelector"
                                :disabled="connected">
                            <label class="form-check-label">rcv-cloud.nl (BaseAC1)</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" value="custom" v-model="mqttBrokerSelector"
                                :disabled="connected">
                            <label class="form-check-label">Custom broker</label>
                        </div>
                        <button type="button" class="btn btn-secondary" @click="disconnect" v-if="connected">
                            Disconnect
                        </button>
                        <button type="button" class="btn btn-success" @click="connect" v-else>
                            Connect
                        </button>
                        <button type="button" class="btn btn-info float-end" v-if="deviceDetailsIndex >= 0"
                            v-on:click="showDetails('')">
                            Back to overview
                        </button>
                        <div class="row" style="margin-top: 10px; max-width: 1000px;" v-if="mqttBrokerSelector == 'custom'">
                            <div class="col">
                                <div class="input-group">
                                    <label class="input-group-text">Protocol</label>
                                    <select class="form-select"  v-model="connection.protocol" :disabled="mqttBrokerSelector != 'custom' || connected">
                                        <option value="ws">ws</option>
                                        <option selected value="wss">wss</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-text">Host</div>
                                    <input type="text" class="form-control" v-model="connection.host" :disabled="mqttBrokerSelector != 'custom' || connected" />
                                </div>                                
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-text">Port</div>
                                    <input type="text" class="form-control" v-model="connection.port" :disabled="mqttBrokerSelector != 'custom' || connected">
                                </div> 
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-text">User</div>
                                    <input type="text" class="form-control" v-model="connection.username" :disabled="mqttBrokerSelector != 'custom' || connected">
                                </div> 
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-text">Password</div>
                                    <input type="password" class="form-control" v-model="connection.password" :disabled="mqttBrokerSelector != 'custom' || connected">
                                </div> 
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div v-if="devices.length > 0">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" value="batteryflex_baseac1"
                                v-model="checkedDeviceTypes" :disabled="deviceDetailsIndex != -1">
                            <label class="form-check-label">BaseAC1</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" value="InREC36" v-model="checkedDeviceTypes"
                                :disabled="deviceDetailsIndex != -1">
                            <label class="form-check-label">InREC</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" value="ACSA" v-model="checkedDeviceTypes"
                                :disabled="deviceDetailsIndex != -1">
                            <label class="form-check-label">ACSA</label>
                        </div>

                        <div class="form-check form-check-inline" style="margin-left: 100px;">
                            <input class="form-check-input" type="checkbox" id="show_only_online" v-model="show_only_online">
                            <label class="form-check-label" for="show_only_online">Only show online</label>
                        </div>
                    </div>
                    <table class="table table-hover" v-if="devices.length > 0">
                        <thead>
                            <tr>
                                <th style="width: 150px;" class="text-center">Status</th>
                                <th style="width: 40px;"></th>
                                <th style="width: 70px;" class="text-center"><i class="bi bi-battery-half"></i></th>
                                <th style="width: 200px;">Topic</th>
                                <th>Nickname</th>
                                <th style="width: 200px;">Host</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(device, index) in devices" :key="index"
                                v-show="(deviceDetailsIndex == -1 || deviceDetail.serial == device.serial) && (checkedDeviceTypes.findIndex(obj => { return obj == device.topic_base }) != -1 && ((device.status != 'offline' && device.descriptiveState.text != 'No data') || !show_only_online))"
                                :class="[(device.status != 'offline' && device.info && device.info.protocol_version && device.descriptiveState.text != 'No data') ? 'table-success' : ((device.status != 'offline' && (device.info == null || device.info.protocol_version == null)) ? 'table-primary' : 'table-secondary')]"
                                v-on:click="showDetails(device.serial)">
                                <td class="text-center">
                                    <span class="badge" :class="[device.descriptiveState.class]">
                                        {{ device.descriptiveState.text }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <i v-if="device.acsa && device.acsa.data && device.acsa.data.system && device.acsa.data.system.autonomous" class="bi bi-building-exclamation"></i>
                                </td>
                                <td class="fw-bold text-end">
                                    {{ device.soc }}
                                </td>
                                <td><span class="font-monospace">{{ device.topic_base + "/" + device.serial }}</span></td>
                                <td>
                                    <span v-if="device.info && device.info.nickname" class="fw-bold">
                                        {{ device.info.nickname }}
                                    </span>
                                </td>
                                <td><small class="font-monospace">{{ get_host_name(device) }}</small></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="alert alert-info" role="alert" v-else>
                        Nothing to show here yet, try connecting to receive data...
                    </div>
                    <div v-if="deviceDetailsIndex >= 0">
                        <div class="d-grid gap-2 d-md-block">
                            <button type="button" class="btn btn-info btn-with-margin" data-bs-toggle="modal"
                                    data-bs-target="#configureModal">
                                    Configuration details
                            </button>
                            <button type="button" class="btn btn-warning btn-with-margin" data-bs-toggle="modal"
                                    data-bs-target="#controlModal" v-if="deviceDetail.status != 'offline' && shared.allow_control">
                                    Control
                            </button>
                            
                            <div class="btn-group btn-with-margin">
                                <a class="btn btn-primary dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Show in Grafana
                                </a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" target="_blank" :href="'https://grafana.rcv-cloud.nl/d/bfe04582-fee5-4721-bc97-b84a157223c9/backup-solo-fut?orgId=1&var-system_serial=' + deviceDetail.serial">BaseAC1 BackUp Solo FUT (legacy)</a></li>
                                    <li><a class="dropdown-item" target="_blank" :href="'https://grafana.rcv-cloud.nl/d/bdkmg7oor2hhcb/backup-solo-fut-new-protocol?orgId=1&var-system_serial=' + deviceDetail.serial">BaseAC1 BackUp Solo</a></li>
                                    <li><hr class="dropdown-divider"></li>
                                    <li><a class="dropdown-item" target="_blank" :href="'https://grafana.rcv-cloud.nl/d/edn9houp02328b/inrec-single?orgId=1&var-system_serial=' + deviceDetail.serial">InREC (single)</a></li>
                                    <li><a class="dropdown-item" target="_blank" :href="'https://grafana.rcv-cloud.nl/d/cdo258shgvugwd/inrec-single-with-acsa?orgId=1&var-system_serial=' + deviceDetail.serial">InREC (single with ACSA)</a></li>
                                    <li><a class="dropdown-item" target="_blank" :href="'https://grafana.rcv-cloud.nl/d/e5250219-4609-4714-b3d2-680b6cca16a2/inrec-cluster?orgId=1&var-system_serial=' + deviceDetail.serial">InREC (cluster)</a></li>
                                    
                                </ul>
                            </div>
                            
                            <button type="button" class="btn btn-danger float-end" data-bs-toggle="modal" data-bs-target="#confirmDeviceDeletionModal" v-if="shared.allow_control">
                                Forget device
                            </button>
                            <button type="button" class="btn btn-primary btn-with-margin float-end" data-bs-toggle="modal" data-bs-target="#hostsModal" @click="open_host(deviceDetail)" v-if="connected">
                                Go to host
                            </button>
                        </div>
                        
                        <br/>

                        <div v-if="!deviceDetail.info || deviceDetail.info.protocol_version == null">
                            <div class="alert alert-danger" role="alert">
                                Protocol not supported by this viewer
                            </div>
                        </div>

                        <div v-if="deviceDetail.status == 'updating'">
                            <div class="alert alert-info" role="alert">
                                Firmware update in progress, live data will not be updated and commands are not processed
                            </div>
                        </div>

                        <div v-if="deviceDetail.status != 'offline'">
                            <div class="row">
                                <div class="col-md-6">
                                    <BaseAC1BMS :deviceDetail="deviceDetail" :client="client" />
                                    <ACSA :deviceDetail="deviceDetail" :client="client" />
                                </div>
                                <div class="col-md-6">
                                    <BaseAC1Aboard :deviceDetail="deviceDetail" />

                                    <InREC :deviceDetail="deviceDetail" :client="client"
                                        :inrecDevice="deviceDetail.inrec" :target="'inrec'" />

                                    <InRECCluster :deviceDetail="deviceDetail" :client="client"
                                        v-if="deviceDetail.inrecs_in_cluster > 0" />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-warning" role="alert">
                                Live data is not available when device is offline
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </div>
    </div>

    <ModalConfig :deviceDetail="deviceDetail" :client="client" />
    <ModalControl :deviceDetail="deviceDetail" :client="client" />
    <HostDevices :hosts="hosts" :client="client" :received_topics="received_topics" :show_details_from_index="show_host_details_from_index" />

    <!-- Device deletion confirmation modal -->
    <div class="modal fade" id="confirmDeviceDeletionModal" tabindex="-1" ref="confirmDeviceDeletionModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Are you sure?</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h6>This will remove the following (retained) topics on the broker by publishing empty payloads</h6>
                    <code v-for="topic in deviceDetail.received_topics">{{topic}}<br/></code>
                    <br/>
                    <h6>Note that these topics are republished when the device comes online again</h6>
                    <hr/>
                    <button type="button" class="btn btn-danger" @click="forgetDevice()" data-bs-dismiss="modal">Forget device</button>
                </div>
            </div>
        </div>
    </div>

    <footer class="footer mt-auto py-3 bg-light">
        <p class="text-center text-muted" style="margin-bottom: 0;"><b>v-{{ app_version }}</b> - © {{ current_year }} -
            REConvert B.V.</p>
    </footer>
    
</template>

<script>
import mqtt from 'mqtt';
import { ref } from 'vue';

export default {
    data() {
        return {
            connection: {
                protocol: 'wss',
                host: null,
                port: null,
                endpoint: '/mqtt',
                clean: true,
                connectTimeout: 30 * 1000, // ms
                reconnectPeriod: 4000, // ms
                clientId:
                    'rcv-explorer-' +
                    Math.random()
                        .toString(16)
                        .substring(2, 8),
                username: null,
                password: null,
            },
            connected: false,
            message: '',
            showMessage: false,
            client: {
                connected: false,
            },
            devices: [],
            deviceDetailsIndex: -1,
            deviceDetail: {},
            target: "",
            parameter: "",
            value: "",
            checkedDeviceTypes: ref(["batteryflex_baseac1", "InREC36", "ACSA"]),
            mqttBrokerSelector: "rcv-cloud",

            hosts: [],
            show_host_details_from_index: -1,

            received_topics: [],

            show_host_log: false,
            show_only_online: false,
        };
    },
    methods: {
        connect() {
            try {
                this.connecting = true

                // Reset filter for online (otherwise glitching)
                this.show_only_online = false

                // Determine which broker to use
                if (this.mqttBrokerSelector == "rcv-cloud-baseac1") {
                    this.connection.protocol = 'wss'
                    this.connection.host = 'rcv-cloud.nl'
                    this.connection.port = 9005
                    this.connection.username = 'rcv_explorer'
                    this.connection.password = 'cDiD8mN7p1S0'
                } else if (this.mqttBrokerSelector == "rcv-cloud") {
                    this.connection.protocol = 'wss'
                    this.connection.host = 'rcv-cloud.nl'
                    this.connection.port = 9001
                    this.connection.username = 'rcv_explorer'
                    this.connection.password = 'cDiD8mN7p1S0'
                }

                const { protocol, host, port, endpoint, ...options } = this.connection
                const connectUrl = `${protocol}://${host}:${port}${endpoint}`
                this.client = mqtt.connect(connectUrl, options)
                if (this.client.on) {
                    this.client.on('connect', () => {
                        this.connecting = false
                        this.connected = true
                        console.log('Connection succeeded!')

                        // Subscribe to the relevant topics
                        var topics = [
                            "rcv-release-versions",
                            
                            "batteryflex_baseac1/+/#",
                            "InREC36/+/#",
                            "ACSA/+/#",
                            
                            "reconvert/#",
                            
                            "batteryflex_baseac1/+/+/#",
                            "InREC36/+/+/#",
                            "ACSA/+/+/#",
                        ]
                        this.client.subscribe(topics, (error, res) => {
                            if (error) {
                                console.log('Subscribe to topics error', error)
                            }
                        })
                    })
                    this.client.on('reconnect', () => {
                        console.log('Reconnected!')
                    })
                    this.client.on('error', error => {
                        console.log('Connection failed', error)
                    })
                    this.client.on('message', (topic, message) => {
                        this.message_received(topic, message)
                    })
                }
            } catch (error) {
                this.connecting = false
                this.connected = false
                console.log('mqtt.connect error', error)
            }
        },
        disconnect() {
            if (this.client.connected) {
                try {
                    this.client.end(false, () => {
                        this.connected = false
                        console.log('Successfully disconnected!')

                        // Clear all data
                        this.devices = []
                        this.deviceDetailsIndex = -1
                        this.deviceDetail = {}
                        this.hosts = []
                        this.received_topics = []
                    })
                } catch (error) {
                    console.log('Disconnect failed', error.toString())
                }
            }
        },
        message_received(topic, message) {
            var topicParts = topic.split('/')
            var index;
            
            if (message == null) {
                return
            }

            // Add to received topics (if it not already existed)
            if (this.received_topics.indexOf(topic) === -1) {
                this.received_topics.push(topic)
            }

            if (topic == "rcv-release-versions") {
                shared.firmware_versions = JSON.parse(message);
            } else if (topicParts[0] == "reconvert") {
                // Host topic
                var hostname = topicParts[1]

                index = this.hosts.findIndex(obj => { return obj.hostname == hostname })
                if (index == -1) {
                    this.hosts.push({ hostname: hostname })
                    index = this.hosts.length - 1
                    //console.log(`New host: ${hostname}, now at index ${index}`)
                }

                if (topicParts[2] == "info" || topicParts[2] == "config") {
                    try {
                        this.hosts[index][topicParts[2]] = JSON.parse(message)
                    } catch (error) {
                        console.error(error)
                    }
                    
                } else {
                    this.hosts[index][topicParts[2]] = message.toString()
                }
            } else {
                // Device topic
                var serial = topicParts[1]

                index = this.devices.findIndex(obj => { return obj.serial == serial })
                if (index == -1) {
                    this.devices.push({ serial: serial, topic_base: topicParts[0], inrecs_in_cluster: 0 })
                    index = this.devices.length - 1
                    //console.log(`New device: ${serial}, now at index ${index}`)
                }

                if (topicParts[2] == "info") {
                    try {
                        this.devices[index].info = JSON.parse(message)
                    } catch (error) {
                        console.error(error)
                    }

                    // Check for cluster of InRECs
                    if (this.devices[index].info.devices) {
                        let highest_index = 0
                        for (var key of Object.keys(this.devices[index].info.devices)) {
                            if (key == "cluster_of_inrec_versions") {
                                if (this.devices[index].info.devices.cluster_of_inrec_versions) {
                                    this.devices[index].inrecs_in_cluster = this.devices[index].info.devices.cluster_of_inrec_versions.length
                                }
                                break
                            } else if (key != "inrec_version" && key.startsWith("inrec_")) {
                                let index = parseInt(key.replace("inrec_", ""))
                                if (index > highest_index) {
                                    highest_index = index
                                }
                            }
                        }
                        if (highest_index > 0) {
                            this.devices[index].inrecs_in_cluster = highest_index
                        }
                        if (this.devices[index].inrecs_in_cluster > 0) {
                            //console.log("InRECs in cluster of device '" + topic + "' is " + this.devices[index].inrecs_in_cluster)
                        }
                    }
                } else if (topicParts[2] == "status" || topicParts[2] == "host_topic") {
                    this.devices[index][topicParts[2]] = message.toString()
                } else if (topicParts[3] == "config" || topicParts[3] == "data" || topicParts[3] == "data_quick" || topicParts[3] == "status") {
                    if (!this.devices[index][topicParts[2]]) {
                        this.devices[index][topicParts[2]] = {}
                    }

                    if (topicParts[3] == "status") {
                        this.devices[index][topicParts[2]][topicParts[3]] = message.toString()
                    } else {
                        try {
                            this.devices[index][topicParts[2]][topicParts[3]] = JSON.parse(message)
                        } catch (error) {
                            console.error(error)
                        }
                    }

                    // If data received, also write to data_quick (legacy support)
                    if (topicParts[3] == "data") {
                        try {
                            this.devices[index][topicParts[2]]["data_quick"] = JSON.parse(message)
                        } catch (error) {
                            console.error(error)
                        }
                    }
                }

                // Update device state
                this.updateDescriptiveDeviceState(index)
                this.updateSoC(index)
            }
        },
        showDetails(serial) {
            var index = this.devices.findIndex(obj => { return obj.serial == serial })
            this.deviceDetailsIndex = index
            if (index >= 0 && index < this.devices.length) {
                this.deviceDetail = this.devices[index]
                
                // Filter all topics from this device
                this.deviceDetail.received_topics = this.received_topics.filter(str => str.includes(this.deviceDetail.topic_base + "/" + this.deviceDetail.serial));
            }
        },
        updateDescriptiveDeviceState(deviceIndex) {
            var state = {}
            var device = this.devices[deviceIndex]

            var has_error = false;
            if ((shared.get_nested_value_safely(device,"aboard.data.system.state") == 8 || shared.get_nested_value_safely(device,"aboard.data.system.state") == 9) ||
                (shared.get_nested_value_safely(device,"inrec.data_quick.system.state") == 8 || shared.get_nested_value_safely(device,"inrec.data_quick.system.state") == 9) ||
                (shared.get_nested_value_safely(device,"acsa.data_quick.system.state") == 8 || shared.get_nested_value_safely(device,"acsa.data_quick.system.state") == 9)) {
                has_error = true
            }

            var is_active = true;
            if ((device.aboard && shared.get_nested_value_safely(device,"aboard.data.system.state") != 7) ||
                (device.inrec && shared.get_nested_value_safely(device,"inrec.data_quick.system.state") != 7)) {
                is_active = false;
            }

            var is_idle = false;
            if (shared.get_nested_value_safely(device,"aboard.data.system.state") == 12) {
                is_idle = true;
            }

            // Check for cluster of InRECs
            var any_cluster_unit_with_data = true;
            if (device.inrecs_in_cluster && device.inrecs_in_cluster > 0) {
                any_cluster_unit_with_data = false;
                for (let index = 1; index <= device.inrecs_in_cluster; index++) {
                    let device_sub = device['inrec_' + (index)]
                    if (shared.get_nested_value_safely(device_sub,"data_quick.system.state") == 8 || 
                        shared.get_nested_value_safely(device_sub,"data_quick.system.state") == 9) {
                        has_error = true;
                    }
                    if (shared.get_nested_value_safely(device_sub,"data_quick.system.state") != 7) {
                        is_active = false;
                    }
                    if (device_sub && (device_sub.data || device_sub.data_quick)) {
                        any_cluster_unit_with_data = true;
                    }
                }
            }

            var no_data = true;
            if ((device.aboard && device.aboard.data) ||
                (device.acsa && (device.acsa.data || device.acsa.data_quick)) ||
                (device.inrec && (device.inrec.data || device.inrec.data_quick)) ||
                (device.inrecs_in_cluster && device.inrecs_in_cluster > 0 && any_cluster_unit_with_data)) {
                no_data = false
            }

            if (device.status == "updating") {
                state = { class: "bg-info", text: "Updating" }
            } else if (device.status != "online") {
                state = { class: "bg-secondary", text: "Offline" }
            } else if (no_data) {
                state = { class: "bg-secondary", text: "No data" }
            } else if (has_error) {
                state = { class: "bg-danger", text: "Error" }
            } else if (is_idle) {
                state = { class: "bg-primary", text: "Idle" }
            } else if (is_active) {
                state = { class: "bg-success", text: "Active" }
            } else {
                state = { class: "bg-warning", text: "Inactive" }
            }


            this.devices[deviceIndex].descriptiveState = state
        },
        updateSoC(deviceIndex) {
            var device = this.devices[deviceIndex]

            if (shared.get_nested_value_safely(device, "bms.data.BMS_Measurement.SoC") != "-") {
                this.devices[deviceIndex].soc = shared.get_nested_value_safely(device, "bms.data.BMS_Measurement.SoC", 0, 0.5) + " %"
            } else if (shared.get_nested_value_safely(device, "inrec.data.bms") != "-") {
                this.devices[deviceIndex].soc = shared.get_nested_value_safely(device, "inrec.data.bms.soc", 0) + " %"
            } else if (device.inrecs_in_cluster > 0) {
                var summed_soc = 0;
                var nof_socs = 0
                for (let index = 1; index <= device.inrecs_in_cluster; index++) {
                    var unit_soc = shared.get_nested_value_safely(device['inrec_' + (index)], "data.bms.soc", 0)
                    if (unit_soc != "-") {
                        summed_soc += parseFloat(unit_soc)
                        nof_socs += 1
                    }
                }
                if (nof_socs > 0){
                    this.devices[deviceIndex].soc = parseFloat(summed_soc / nof_socs).toFixed(0) + " %"
                } else {
                    this.devices[deviceIndex].soc = ""
                }
            } else {
                this.devices[deviceIndex].soc = ""
            }
        },
        forgetDevice() {
            for (const topic of this.deviceDetail.received_topics) {
                this.client.publish(topic, null, { qos: 0, retain: true }, error => {
                    if (error) {
                        console.log('Publish error', error)
                    }
                })
            }

            console.log("Forgetting device ", this.deviceDetail.topic_base + "/" + this.deviceDetail.serial)

            // Disconnect and reconnect to broker
            this.disconnect()
            this.connect()   
        },
        get_host_name(device) {
            if (device == null || device.host_topic == null) {
                return ""
            } else {
                return device.host_topic.replace("reconvert/","").replace("/","")
            }
        },
        open_host(device) {
            const hostname = this.get_host_name(device)

            const found = this.hosts.findIndex((element) => (element.hostname) == hostname);

            this.show_host_details_from_index = found
        }
    }
};
</script>